export const BILL_GENERATION_PAGE_PATTERN = '/bill-generation';
export const RATES_PAGE_PATTERN = '/rates';
export const CHECKOUT_RATES_PAGE_PATTERN = '/app/checkout-rates';

export const RATES_PAGE_LINK = 'https://vchasno.ua/rates';

export const KEP_FOP_REGISTRATION_PATHNAME = `/app/applications/new-proxy`;
